import React, { useState, useEffect } from "react";
import { graphql, Link, useStaticQuery } from "gatsby";

import * as styles from "./navbar.module.scss"
import logo from "../images/logo-dark.svg"


const Navbar = () => {
    const data = useStaticQuery(graphql`
        query {
            pages:allMarkdownRemark(
                filter: {frontmatter: {menu: {eq: true}}}
                sort: {fields: frontmatter___order}
            ) {
                edges {
                    node {
                        id
                        frontmatter {
                            title
                        }
                        fields {
                            slug
                        }
                    }
                }
            }
        }
    `).pages.edges;

    const [open, setOpen] = useState(false);

    useEffect(() => {
        document.body.style.overflow = open ? "hidden" : "";
        return () => { document.body.style.overflow = ""; };
    }, [open]);

    const links = [
        { to: "/", label: "Accueil" },
        { to: "/timeline/", label: "Le Bagad" },
        ...data.map(edge => ({ to: edge.node.fields.slug, label: edge.node.frontmatter.title })),
    ];

    return (
        <nav className={`${styles.nav} ${open ? styles.open : ""}`}>
            <div className={`container ${styles.bar}`}>
                <Link className={styles.brand} to="/" onClick={() => setOpen(false)}>
                    <img src={logo} alt="" width={36} height={35}/>
                    <span className="display">Bagad Men Ru</span>
                </Link>

                <ul className={styles.links}>
                    {links.map(link =>
                        <li key={link.to}>
                            <Link to={link.to} className={styles.link} activeClassName={styles.active}>{link.label}</Link>
                        </li>
                    )}
                </ul>

                <div className={styles.actions}>
                    <a href="https://membres.bagadmenru.bzh/" className={styles.members}>
                        <span className="fas fa-lock" aria-hidden="true"/>
                        <span>Espace membres</span>
                    </a>
                    <button type="button" className={styles.burger} aria-label="Menu" aria-expanded={open} onClick={() => setOpen(!open)}>
                        <span/><span/><span/>
                    </button>
                </div>
            </div>

            <div className={styles.drawer} aria-hidden={!open}>
                <ul>
                    {links.map((link, i) =>
                        <li key={link.to}>
                            <Link to={link.to} activeClassName={styles.drawerActive} onClick={() => setOpen(false)}>
                                <span className={styles.drawerIndex}>{String(i + 1).padStart(2, "0")}</span>
                                <span className="display">{link.label}</span>
                            </Link>
                        </li>
                    )}
                </ul>
                <a href="https://membres.bagadmenru.bzh/" className="btn btn-white btn-lg w-full">
                    <span className="fas fa-lock me-2" aria-hidden="true"/>Espace membres
                </a>
            </div>
        </nav>
    )
}

export default Navbar
